module.exports = __webpack_public_path__ + "img/box_bg.b977fc25.jpg";